var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 3.9,
    cy: 19.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3.9,
    cy: 19.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.8,15.4c0.6-0.3,1.3-0.5,2-0.5c1.8,0,3.3,1.1,4,2.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1,
    cy: 19.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.1,
    cy: 19.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.6,2.5h2.2c0.3,0,0.6,0.2,0.7,0.6l3.5,16.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "6.2,19.6 14.9,19.6 16.1,17.8 5.7,17.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 13.9,
    x2: 16.1,
    y2: 17.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEScooter);
export default __webpack_public_path__ + "static/media/e-scooter.8d9cb7f7271caca3752f6282065d3171.svg";
export { ForwardRef as ReactComponent };